import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const CategoryGardenIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    height="24"
    optimizationId="tama-category-garden"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      className="fill-brand-primary"
      d="M17.7928 10.8174H6.24346C6.07026 10.8113 5.9042 10.8867 5.79111 11.0212C5.67904 11.1567 5.63319 11.337 5.66579 11.5112L6.02849 13.8148C6.10287 14.207 6.43195 14.4933 6.82216 14.5066H6.96173L7.62499 21.0005C7.70853 21.5619 8.17108 21.9817 8.72532 22H15.2152C15.7236 21.9908 16.1648 21.6363 16.2942 21.132V21.1126L17.043 14.5188H17.1388C17.5392 14.5127 17.8815 14.2203 17.9599 13.8178L18.3675 11.5092C18.4062 11.335 18.3624 11.1526 18.2493 11.0161C18.1352 10.8796 17.9671 10.8062 17.7928 10.8174Z"
    />
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M17.9486 3.55518C17.9802 3.31576 17.7825 3.11505 17.5431 3.14358C16.672 3.2475 15.0307 3.59186 13.8886 4.73906C12.7618 5.87097 12.3869 7.5021 12.2636 8.39357C12.2269 8.65541 12.4439 8.87548 12.7068 8.84287C13.5881 8.73284 15.1947 8.38135 16.3185 7.25249C17.4626 6.10224 17.8314 4.43647 17.9486 3.55518Z"
      fillRule="evenodd"
    />
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M10.1566 7.6508C10.4184 7.70072 10.6456 7.47964 10.6029 7.21678C10.4623 6.35893 10.067 4.85311 8.96255 3.74769C7.79498 2.58012 6.12717 2.15323 5.27339 2.00449C5.07574 1.96985 4.90254 2.14101 4.93107 2.33866C5.05333 3.169 5.43131 4.77059 6.59073 5.93001C7.70329 7.04358 9.27227 7.48372 10.1566 7.6508Z"
      fillRule="evenodd"
    />
  </Svg>
));

CategoryGardenIcon.displayName = 'CategoryGardenIcon';
